import {startCase} from 'lodash'
import React from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'

type Props = {
  show: boolean
  handleClose: () => void
  data: any
}

const UploadDone: React.FC<Props> = ({show, handleClose, data}) => {
  const intl = useIntl()

  const renderError = (error: string) => {
    const [input, messageId, value] = error.split('|')

    return intl.formatMessage(
      {id: messageId || input},
      {
        input: startCase(input),
        min: value,
        max: value,
      }
    )
  }

  return (
    <Modal
      id='gori_adjustment_upload_modal'
      tabIndex={-1}
      aria-hidden='true'
      centered
      dialogClassName='modal-size-md h-auto'
      contentClassName='modal-padding'
      show={show}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title bsPrefix={'fw-bolder fs-1'}>
          {intl.formatMessage({id: 'UPLOAD_USPS_CLAIM'})}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='vh-75 overflow-auto'>
        <h4>
          <span className='text-danger'>
            {intl.formatMessage({id: 'ERRORS'})}: {Object.values(data?.errors).length ?? 0}
          </span>
        </h4>
        <h4>
          <span className='text-primary'>
            {intl.formatMessage({id: 'TOTAL'})}: {Object.values(data?.success).length ?? 0}
          </span>
        </h4>
        <hr />
        <div className='timeline-label'>
          {data?.errors &&
            Object.values(data.errors).map((value: any, index) => {
              let line = Object.keys(data.errors)[index]
              return (
                <div className='timeline-item' key={index}>
                  <div className='timeline-label fw-bolder text-gray-800 fs-8'>
                    {' '}
                    {intl.formatMessage({id: 'ROW'})} {line}
                  </div>
                  <div className='timeline-badge'>
                    <i
                      className='fa fa-genderless dashboard-theme-color-green fs-1 dashboard__activity__color-gray'
                      aria-hidden='true'
                    ></i>
                  </div>
                  <div className='timeline-content d-flex'>
                    <span className='fw-bolder text-gray-800 ps-3'>
                      <span className='fs-5 me-3 dashboard__activity__color-gray'>
                        {Object.values(value['fields']).map((item: any, index) => {
                          return (
                            <p key={index} className='text-danger'>
                              {renderError(item[0])}
                            </p>
                          )
                        })}
                      </span>
                    </span>
                  </div>
                </div>
              )
            })}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export {UploadDone}
